import { createFileRoute, Navigate } from '@tanstack/react-router';
import { MainLayout } from '@/components/layout/MainLayout';
import { useAuth } from '@/lib/hooks';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/_auth')({
  component: AuthLayoutComponent,
});

function AuthLayoutComponent() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return (
    <MainLayout>
      {/*<Outlet />*/}
    </MainLayout>
  );
}
